import ActionLogEntries from '../../../store/action_log';

angular
    .module('festzelt-os.modules.action_log')
    .factory('ActionLogEntries', [
        '$injector',
        ($injector) => new ActionLogEntries(() => {}, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/action_log/store/action-log-entries.js